export function trimProviderIds(scopes: string[]): string[] {
    return scopes?.map(s => s.split('.')[0]);
}
